<template>
  <div
    class="mine_conten"
    style="padding-bottom: 1.5rem"
    :style="`background-image:url(${coloImgactivity});background-size: 100%;background-position: 0px 0px;`"
  >
    <div
      v-if="showTipsBox"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 2000;
        backdrop-filter: blur(0.1rem) saturate(100%); /* 模糊 + 饱和度提升 */
        -webkit-backdrop-filter: blur(0.1rem) saturate(100%);
        display: flex;
        justify-content: center;
        align-items: center;
      "
      @click.stop=""
    >
      <div
        style="
          width: 6rem;
          margin: 0 auto;
          left: 0;
          right: 0;
          background: var(--theme-btm-bg-color);
          border-radius: 0.2rem;
          backface-visibility: hidden;
          overflow: auto;
          min-height: 3rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <div
          style="
            text-align: center;
            font-size: 0.3rem;
            font-weight: 400;
            color: #fff;
            padding: 0.2rem 0.3rem 0.3rem;
            box-sizing: border-box;
          "
        >
          {{ $t('mine._Lembrete') }}
        </div>
        <div
          style="
            color: #fff;
            font-size: 0.22rem;
            line-height: 1.64;
            letter-spacing: normal;
            white-space: pre-wrap;
            text-align: center;
            word-wrap: break-word;
            flex: 1;
            padding: 0 0.3rem 0.2rem;
            box-sizing: border-box;
            min-height: 0.92rem;
          "
        >
          {{ $t('common.mineText6') }}
        </div>
        <div
          class="flex justify-between items-center"
          style="
            overflow: hidden;
            user-select: none;
            padding: 0.2rem 0.3rem 0.3rem;
            box-sizing: border-box;
            gap: 0.2rem;
          "
        >
          <div
            class="flex justify-center items-center"
            style="
              width: 100%;
              height: 0.7rem;
              border-radius: 0.14rem;
              border: 0.01rem solid var(--theme-mine-icon-color);
              font-size: 0.24rem;
              line-height: 1.2;
              text-align: center;
              color: var(--theme-mine-icon-color);
            "
            @click="showTipsBox = false"
          >
            {{ $t('Login._Fechar') }}
          </div>
          <div
            class="flex justify-center items-center"
            style="
              width: 100%;
              height: 0.7rem;
              border-radius: 0.14rem;
              font-size: 0.24rem;
              line-height: 1.2;
              text-align: center;
              background-color: var(--theme-mine-icon-color);
              color: var(--theme-text-color-darken);
            "
            @click="
              $store.commit('publicFun', ['AppDownload', true]),
                (showTipsBox = false)
            "
          >
            {{ $t('_home._BaixarAgora') }}
          </div>
        </div>
      </div>
    </div>
    <div class="CToeIaCnZ7Jr3D1XKTxw">
      <div
        style="
          padding: 0.16rem 0.14rem;
          width: 0.32rem;
          height: 0.32rem;
          box-sizing: content-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          z-index: 2;
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          color: var(--theme-text-color-darken);
        "
        @click="goBack"
      >
        <svg-icon
          className="imageWrap"
          icon-class="comm_icon_fh--svgSprite:all"
          style="width: 0.22rem; height: 0.22rem"
        />
      </div>
      <header
        v-if="vuex_token_head"
        class="DiNiMDlhVGqZnjLoStS4"
        style="color: var(--theme-text-color-darken)"
      >
        <div class="flex justify-center items-center">
          <div class="So_waOZgg7qEl0wURIQz" @click="openUrl('notice')">
            <div class="" style="color: var(--theme-text-color-darken)">
              <svg-icon
                slot="left-icon"
                style="width: 0.48rem; height: 0.48rem; margin-left: 0.3rem"
                classNameQita
                icon-class="icon-mine-kf"
              />
            </div>
          </div>
          <div
            class="So_waOZgg7qEl0wURIQz"
            @click="openUrl('notice', { active: 1 })"
          >
            <div class="HY5zlQQwDl4OlzKNd0jr" style="position: relative">
              <div class="" style="color: var(--theme-text-color-darken)">
                <svg-icon
                  slot="left-icon"
                  style="width: 0.48rem; height: 0.48rem; margin-left: 0.3rem"
                  classNameQita
                  icon-class="icon-mine-message"
                />
              </div>
            </div>
          </div>
        </div>
      </header>
      <header v-else style="min-height: 0.5rem;margin-bottom: 0.4rem;"></header>
      <div v-if="vuex_token_head" class="SVLWJ4WJI54O4lWBc7yk">
        <div class="P_VF1DJcPs_q4ieRYz7n">
          <img
            style="width: 100%; height: 100%; border-radius: 50%"
            :src="$store.state.config.user_avatar_image"
            alt=""
          />
          <div
            class="flex justify-center items-center"
            style="
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
              background: var(--theme-mine-icon-color);
              position: absolute;
              bottom: 0;
              right: 0;
            "
            @click="jumpUrl('setting')"
          >
            <svg-icon
              slot="left-icon"
              style="
                width: 0.4rem;
                height: 0.4rem;
                cursor: pointer;
                color: var(--theme-btm-bg-color);
              "
              classNameQita
              icon-class="icon-mine-edit"
            />
          </div>
        </div>
        <div class="zvrVqQuEWSzu7Nsavegl">
          <div
            class="NeL_d0h5i7Kr9xdDCTty flex items-center"
            style="position: relative"
          >
            <div
              class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI flex items-center"
              style="cursor: pointer"
              @click="isShowChoose = true"
            >
              <svg-icon
                slot="left-icon"
                style="width: 0.15rem; height: 0.15rem; transition: 500ms"
                classNameQita
                icon-class="icon-mine-down"
                :style="{ transform: isShowChoose ? 'rotate(180deg)' : '' }"
              />
            </div>
            <div class="flex items-center" v-if="chooseInfo == 'name'">
              <span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.user_name }}</span>
              <span
                @click="copyContent(userInfo.user_name)"
                class="wJ30VxmrZK3Y5gTd1Zq0"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.28rem; height: 0.28rem; cursor: pointer"
                  classNameQita
                  icon-class="icon-copy"
                />
              </span>
            </div>
            <div class="flex items-center" v-else>
              <span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.phone }}</span>
            </div>
            <div
              v-if="isShowChoose"
              style="
                width: 100dvw;
                height: 100dvh;
                position: fixed;
                left: 0;
                top: 0;
              "
              @click="isShowChoose = false"
            ></div>
            <div
              v-if="isShowChoose"
              style="
                border-radius: 0.14rem;
                box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.1);
                border: 0.01rem solid var(--theme-color-line);
                background: var(--theme-text-color-darken);
                padding: 0.2rem 0.2rem 0.15rem;
                display: flex;
                flex-direction: column;
                min-width: 4.2rem;
                position: absolute;
                top: 0.35rem;
                left: 0;
                z-index: 100;
              "
            >
              <div style="margin-bottom: 0.14rem; color: #fff">
                {{ $t('common.mineText2') }}
              </div>
              <div
                class="flex items-center"
                style="gap: 0.1rem; height: 0.8rem"
                :style="{
                  color:
                    chooseInfo == 'name'
                      ? 'var(--theme-mine-icon-color)'
                      : 'var(--theme-text-color)'
                }"
                @click="(chooseInfo = 'name'), (isShowChoose = false)"
              >
                <svg-icon
                  className="imageWrap"
                  style="width: 0.3rem; height: 0.3rem"
                  icon-class="input_icon_zh--svgSprite:all"
                />
                <span>{{ userInfo.user_name }}</span>
              </div>
              <div
                class="flex items-center"
                style="gap: 0.1rem; height: 0.8rem"
                :style="{
                  color:
                    chooseInfo == 'phone'
                      ? 'var(--theme-mine-icon-color)'
                      : 'var(--theme-text-color)'
                }"
                @click="(chooseInfo = 'phone'), (isShowChoose = false)"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.3rem; height: 0.3rem"
                  classNameQita
                  icon-class="icon-mine-phone"
                />
                <span>{{ userInfo.phone }}</span>
              </div>
            </div>
          </div>
          <div class="Fn6L7w5ZEXiwo2fTNrRn">
            <div class="glbY5bkp9x7KTYOGrdBC">
              <span class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI">ID:</span
              ><span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.id }}</span>
              <div
                @click="copyContent(userInfo.id)"
                class="wJ30VxmrZK3Y5gTd1Zq0 flex justify-center items-center"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.28rem; height: 0.28rem; cursor: pointer"
                  classNameQita
                  icon-class="icon-copy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="SVLWJ4WJI54O4lWBcsdfsdf">
        <div class="no-login-left">
          <div style="flex-wrap: wrap; display: flex; align-items: center">
            <span class="_action_1u010_97">{{ $t('common.mineText1') }}</span>
          </div>
          <div class="crcd82r1PVsQivOcCftk">
            <van-button
              style="margin-left: 0"
              @click="
                $store.commit('isRecord'),
                  $store.commit('publicFun', ['isRecordType', 1])
              "
              type="primary"
              size="mini"
              >{{ $t('Login._Login') }}</van-button
            >
            <van-button
              @click="
                $store.commit('isRecord'),
                  $store.commit('publicFun', ['isRecordType', 0])
              "
              type="default"
              size="mini"
            >
              {{ $t('Login._Registro') }}
            </van-button>
          </div>
        </div>
        <img
          src="@/assets/icons/3Dian1/mine-giftbig.webp"
          alt=""
          style="
            width: 1.98rem;
            height: 2rem;
            position: absolute;
            bottom: -0.4rem;
            right: 0.25rem;
          "
        />
      </div>
    </div>
    <div
      v-if="vuex_token_head"
      style="
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: auto;
        padding: 0 0.25rem;
        color: var(--theme-text-color-darken);
      "
    >
      <div class="Fn6L7w5ZEXiwo2fTNrRn">
        <div class="glbY5bkp9x7KTYOGrdBC">
          <i
            data-id="sprite_main_flag_1x1_Brazil"
            aria-hidden="true"
            focusable="false"
            class=""
            :style="`display: inline-block; position: relative; width: 0.34rem; height: 0.34rem; background-image: url(${_coloImg}); background-position: ${conutryPosion}; background-size: 8.81571rem 8.60321rem;`"
          ></i>
          <div
            class="vy918omw_N7rBkJ235XX IMl873FTgqqNlSitFJrT iyrfQ72Vih_uHUFOsiR4 currencyInfoBox main VOgj9FBCnkozjr2NA7rl"
            style="--row-align: center; --mode: flex; --column-align: center"
          >
            <section
              class="iw9FDOIygJyoQtUHSJAg currency-count"
              style="font-size: 0.18rem"
            >
              <div class="countTextBox">
                <span
                  class="SSAbrhtT3U690CrzLUd5 SSYrjrFkdeGEfKeXOPu3 count-to"
                >
                  <span class="notranslate">{{ userBalance }}</span>
                </span>
                <div
                  class="refresh-icon"
                  :class="{
                    animate__manimated: animate__manimated
                  }"
                  @click="animate_conter"
                >
                  <svg-icon
                    className="refresh-icon"
                    style="cursor: pointer"
                    icon-class="style_1_icon_sx--svgSprite:all"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="flex justify-center items-center" style="width: 3.46rem">
        <div
          class="moneybox"
          style="margin-right: 0.14rem"
          @click="showDeposit"
        >
          <img src="../../assets/icons/3Dian1/mine-recharge.webp" alt="" />
          <span>
            {{ $t('mine._Depósito') }}
          </span>
        </div>
        <div
          class="moneybox"
          @click="
            jumpUrl(userInfo.set_withdraw_password ? 'withdraw' : 'security')
          "
        >
          <img src="../../assets/icons/3Dian1/mine-withdraw.webp" alt="" />
          <span>
            {{ $t('_home._Saques') }}
          </span>
        </div>
      </div>
    </div>
    <div class="checkInBox" v-if="dailySignIn.list.length > 0">
      <div class="flex justify-center items-center">
        <div>
          <div
            style="
              color: #fff;
              font-size: 0.28rem;
              line-height: 0.38rem;
              height: 0.38rem;
              font-weight: 700;
              margin-bottom: 0.04rem;
            "
          >
            {{ $t('common.mineText3') }}
          </div>
          <div style="color: var(--theme-text-color); font-size: 0.24rem">
            {{ $t('common.mineText4') }}
          </div>
        </div>
        <div
          style="
            position: relative;
            background: var(--theme-mine-icon-color);
            color: var(--theme-text-color-darken);
            font-size: 0.22rem;
            line-height: 0.36rem;
            height: 0.36rem;
            padding: 0 0.06rem 0 0.1rem;
            border-radius: 0 1rem 1rem 0;
            cursor: pointer;
            width: 1.23rem;
            margin-left: 0.45rem;
            display: flex;
            justify-content: space-between;
          "
          @click="jumpUrl('event')"
        >
          <img
            src="../../assets/icons/3Dian1/mine-gift.webp"
            alt=""
            style="
              position: absolute;
              left: -0.43rem;
              top: -0.1rem;
              width: 0.55rem;
              height: 0.56rem;
            "
          />
          <span
            style="
              width: 0.89rem;
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
          >
            {{ $t('common.mineText5') }}
          </span>
          <div
            style="
              transform: scaleX(-1);
              margin-left: 0.02rem;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <svg-icon
              className="imageWrap"
              icon-class="comm_icon_fh--svgSprite:all"
              style="width: 0.15rem; height: 0.15rem"
            />
          </div>
        </div>
      </div>
      <div
        ref="scrollContainer"
        style="
          display: flex;
          padding-top: 0.2rem;
          flex-direction: row;
          gap: 0.1rem;
          overflow-x: scroll;
          scroll-behavior: smooth;
          width: 6.62rem;
        "
        @scroll="handleScroll"
      >
        <div
          class="arrow-left"
          style="display: flex"
          @click="toLeft"
          v-if="showScrollBtnleft"
        >
          <svg-icon
            className="imageWrap"
            icon-class="comm_icon_fh--svgSprite:all"
            style="width: 0.18rem; height: 0.18rem"
          />
        </div>
        <div
          class="arrow-right"
          style="display: flex"
          @click="toRight"
          v-if="showScrollBtnRight"
        >
          <svg-icon
            className="imageWrap"
            icon-class="comm_icon_fh--svgSprite:all"
            style="width: 0.18rem; height: 0.18rem; transform: rotate(180deg)"
          />
        </div>
        <div
          v-for="item in dailySignIn.list"
          :class="
            activeDay == item.day ? 'checkInMoneyBox active' : 'checkInMoneyBox'
          "
        >
          <div style="margin-top: 0.02rem">
            <div class="checkInMoneyBox_itemMoneyText">
              {{ item.bonus }}
            </div>
          </div>
          <div
            style="
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 1.01rem;
            "
          >
            <div class="checkInMoneyBox_itemMoneyImg" style="display: flex">
              <img :src="item.icon" style="width: 100%; height: 100%" alt="" />
            </div>
          </div>
          <div
            v-if="activeDay == item.day"
            class="checkInMoneyBox_itemDay"
            style="display: flex"
            @click="ReceberTudo"
          >
            <div style="display: flex">{{ $t('components._Entrar') }}</div>
          </div>
          <div v-else class="checkInMoneyBox_itemDay" style="display: flex">
            D {{ item.day }}
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: relative;
        margin: 0.3rem 0.25rem 0.2rem;
        border-radius: 0.2rem;
        padding: 0.1rem 0.2rem;
        background: var(--theme-btm-bg-color);
        box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.06);
      "
    >
      <div
        style="
          color: #fff;
          font-size: 0.28rem;
          line-height: 0.38rem;
          height: 0.38rem;
          font-weight: 700;
          margin-bottom: 0.04rem;
        "
      >
        {{ $t('common.mineText7') }}
      </div>
      <div>
        <div
          style="
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            margin-top: -0.1rem;
          "
        >
          <div class="flex justify-center" v-for="item in 12" :span="6">
            <div
              v-if="item < 12"
              class="mine-function-item"
              @click="toItemFunction(item)"
            >
              <div v-if="item == 1" class="item-activity">
                <div class="ui-badge__content">500%</div>
              </div>
              <div
                style="
                  width: 0.47rem;
                  height: 0.47rem;
                  position: relative;
                  display: flex;
                "
                class="justify-center items-center"
              >
                <svg-icon
                  v-if="item !== 7"
                  slot="left-icon"
                  style="color: #fff"
                  classNameQita
                  :icon-class="`icon-mine-function${item * 2 - 1}`"
                  class="item-svg"
                />
                <svg-icon
                  slot="left-icon"
                  :style="{
                    color:
                      item == 7 ? '#20f511' : 'var(--theme-mine-icon-color)'
                  }"
                  classNameQita
                  :icon-class="`icon-mine-function${item * 2}`"
                  class="item-svg"
                />
              </div>
              <div class="item-text">
                {{ $t(`mine._function${item}`) }}
              </div>
            </div>
            <div
              v-if="item == 12 && vuex_token_head"
              class="mine-function-item"
              @click="Saireiniciarsess"
            >
              <div
                style="
                  width: 0.47rem;
                  height: 0.47rem;
                  position: relative;
                  display: flex;
                "
                class="justify-center items-center"
              >
                <svg-icon
                  slot="left-icon"
                  style="color: #fff"
                  classNameQita
                  :icon-class="`icon-mine-function${item * 2 - 1}`"
                  class="item-svg"
                />
                <svg-icon
                  slot="left-icon"
                  style="color: var(--theme-mine-icon-color)"
                  classNameQita
                  :icon-class="`icon-mine-function${item * 2}`"
                  class="item-svg"
                />
              </div>
              <div class="item-text">
                {{ $t(`mine._function${item}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <APopup :isShow="isShow" @_remove="_remove"></APopup>
    <MyToast
      :isShow="isMyToast"
      @cancel="isMyToast = false"
      @confirm="openConfirm"
      :model="{
        title: $t('components._Falhanocheckin'),
        message: message,
        buttomValue: $t('components._Irparadepsito'),
        type: 'fail' //success fail
      }"
    ></MyToast>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Dialog } from 'vant';
import APopup from '@/components/Idioma-popup/index.vue';
import { dailySignIn, doDailySign } from '@/apis/modules/detail.js';
import MyToast from '@/components/MyToast/index.vue';
import { Toast } from 'vant';

export default {
  name: 'records',
  computed: {
    // ...mapState(['popList','userInfo','moneyInfo'])
    popList() {
      return this.$store.state.popList || [];
    },
    userInfo() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.vip_info) {
        return this.$store.state.userInfo;
      } else {
        return { vip_info: {} };
      }
    },

    moneyInfo() {
      return this.$store.state.moneyInfo;
    },
    ...mapState(['vuex_token_head'])
  },
  components: {
    APopup,
    MyToast
  },
  data() {
    return {
      coloImgactivity: require('@/assets/icons/images/style_1_topbg_yd.webp'),
      isShow: false,
      animate__manimated: false,
      conutryPosion: '-8.11143rem -3.16929rem',
      userBalance: '0,00',
      chooseInfo: 'name',
      isShowChoose: false,
      activeDay: 1,
      showScrollBtnleft: false,
      showScrollBtnRight: true,
      showTipsBox: false,
      dailySignIn: {},
      isMyToast: false,
      message: false,
      mesnComenste: false
    };
  },
  created() {
    if (this.$store.state.config.currency == 'R$') {
      this.conutryPosion = '-8.11143rem -3.16929rem';
    } else if (this.$store.state.config.currency == '$') {
      this.conutryPosion = '-7.25143rem -7.47929rem';
    } else if (this.$store.state.config.currency == '₹') {
      this.conutryPosion = '-8.11143rem -1.04029rem';
    } else if (this.$store.state.config.currency == '¢') {
      this.conutryPosion = '-2.14143rem -8.24029rem';
    } else if (this.$store.state.config.currency == 'M$') {
      this.conutryPosion = '-8.11143rem -4.92629rem';
    } else if (this.$store.state.config.currency == '₦') {
      this.conutryPosion = '-1.05143rem -7.98829rem';
    } else if (this.$store.state.config.currency == '₱') {
      this.conutryPosion = '-8.11143rem -2.80929rem';
    }
    this.showBalance();
    dailySignIn({}).then(({ code, data, msg }) => {
      this.dailySignIn = data;
      this.activeDay = data.now_day;
    });
  },
  watch: {
    moneyInfo: {
      handler(val) {
        this.showBalance();
      },
      deep: true
    }
  },
  methods: {
    openConfirm() {
      this.isMyToast = false;
      this.mesnComenste = false;
      setTimeout(() => {
        this.$store.commit('isDeposit', true);
      }, 300);
    },
    checkLogin() {
      if (!this.vuex_token_head) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    ReceberTudo() {
      if (!this.checkLogin()) return;
      doDailySign({
        activity: 'lossSubsidy'
      }).then(({ code, data, msg }) => {
        //404
        if (code == 1) {
          this.isMyToast = true;
          this.message = msg;
          return false;
        } else if (code == 0) {
          Toast.success(msg);
          this.getNotification();
        } else {
          Toast.loading(msg);
        }
      });
    },
    toItemFunction(num) {
      if (num == 1) {
        this.jumpUrl('yuebao');
      }
      if (num == 2) {
        this.jumpUrl('report');
      }
      if (num == 3) {
        this.jumpUrl(
          this.userInfo.set_withdraw_password ? 'withdraw' : 'security',
          {
            current: 2
          }
        );
      }
      if (num == 4) {
        this.jumpUrl('vip');
      }
      if (num == 5) {
        this.jumpUrl('promote');
      }
      if (num == 6) {
        this.jumpUrl('setting');
      }
      if (num == 7) {
        this.jumpUrl('securityConter');
      }
      if (num == 8) {
        this.isShow = !this.isShow;
      }
      if (num == 9) {
        this.jumpUrl('notice');
      }
      if (num == 10) {
        // this.jumpUrl('');
      }
      if (num == 11) {
        this.jumpUrl('device-info');
      }
    },
    convertEmToPx(emValue) {
      const fontSize = parseFloat(
        window.getComputedStyle(document.documentElement).fontSize
      );
      return emValue * fontSize;
    },
    handleScroll() {
      const container = this.$refs.scrollContainer;
      console.log(container.scrollLeft, 'container.scrollLeft');
      // 左侧到底
      if (container.scrollLeft == 0) {
        this.showScrollBtnleft = false;
        this.showScrollBtnRight = true;
      } else {
        this.showScrollBtnleft = true;
      }
      // 右侧到底
      if (
        container.scrollWidth - container.scrollLeft <=
        container.clientWidth
      ) {
        this.showScrollBtnleft = true;
        this.showScrollBtnRight = false;
      } else {
        this.showScrollBtnRight = true;
      }
    },
    toLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft -= this.convertEmToPx(6.695);
    },
    toRight() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft += this.convertEmToPx(6.695);
    },
    goBack() {
      this.$router.go(-1);
    },
    jumpUrl(path, params) {
      if (this.vuex_token_head) {
        this.openUrl(path, params);
      } else {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 1]);
      }
    },
    animate_conter(e) {
      //
      this.animate__manimated = true;
      this.getBalance();
      let time = setTimeout(() => {
        clearTimeout(time);
        this.animate__manimated = false;
      }, 300);
    },
    showBalance() {
      this.userBalance = this.$store.state.config.balance_no_bonus.includes(
        'user_center'
      )
        ? this.moneyInfo.balance_coin_str
        : this.moneyInfo.balance_total_str;
    },
    Saireiniciarsess() {
      let _this = this;
      Dialog.confirm({
        title: this.$t('mine._Lembrete'),
        message: this.$t('mine._Desejaterminarsessãodaconta'),
        confirmButtonText: this.$t('mine._Cancelar'),
        cancelButtonText: this.$t('mine._Confirmarsaída')
      })
        .then(() => {})
        .catch(() => {
          _this.$router.push({ name: 'home' });
          this.$vuex('vuex_token_head', {});
          this.$vuex('vuex_token', '');
          setTimeout(() => {
            location.reload();
          });
        });
    },
    _remove() {
      //
      this.isShow = false;
    },
    tabFun(e) {
      this.$store.commit('active', e);
    },
    stickyScroLL(e) {},

    // 获取指定路由的徽章数量
    getBadgeCount() {
      if (this.moneyInfo && this.moneyInfo.have_message) {
        return this.moneyInfo.have_message;
      } else {
        return 0;
      }
    },

    // 格式化徽章数字显示
    formatBadgeCount(count) {
      if (count <= 0) return '';
      if (count > 99) return '99+';
      return count.toString();
    },
    showDeposit() {
      if (this.vuex_token_head) {
        this.$store.commit('isDeposit', true);
      } else {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 1]);
      }
    }
  }
};
</script>
<style scoped>
.mine_conten {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-color: var(--theme-main-bg-color);
  .checkInBox {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0.3rem 0.25rem 0.2rem;
    border-radius: 0.2rem;
    padding: 0.1rem 0.2rem;
    background: var(--theme-btm-bg-color);
    box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.06);
    .arrow-left,
    .arrow-right {
      position: absolute;
      width: 0.36rem;
      height: 0.36rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.36rem;
      bottom: 0.58rem;
      background-color: rgba(0, 0, 0, 0.2);
      color: #fff;
      z-index: 1000;
    }
    .arrow-left {
      left: 0.08rem;
    }
    .arrow-right {
      right: 0.08rem;
    }
    .checkInMoneyBox {
      position: relative;
      z-index: 1;
      width: 1rem;
      height: 1.32rem;
      border: 0.01rem solid var(--theme-text-color);
      border-radius: 0.14rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .checkInMoneyBox_itemMoneyText {
        color: var(--theme-secondary-color-finance);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        width: 100%;
        height: 0.33rem;
        font-size: 0.24rem;
        line-height: 0.33rem;
        text-align: center;
      }
      .checkInMoneyBox_itemMoneyImg {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.48rem;
        height: 0.48rem;
        margin: 0.03rem 0;
      }
      .checkInMoneyBox_itemDay {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.35rem;
        padding-top: 0;
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .active {
      border-color: #20f511;
      .checkInMoneyBox_itemDay {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.35rem;
        padding-top: 0;
        color: #fff;
        font-size: 0.2rem;
        div {
          background: #20f511;
          width: 0.8rem;
          height: 0.35rem;
          border-radius: 0.5rem;
          padding: 0 0.05rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
.mine-function-item {
  margin-top: 0.3rem;
  width: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--theme-text-color);
  text-align: center;
  position: relative;
  .item-activity {
    color: rgb(255, 255, 0);
    background-color: red;
    height: 0.26rem;
    text-align: center;
    border-radius: 0.13rem 0.13rem 0.13rem 0;
    font-size: 0.18rem;
    font-weight: 400;
    line-height: 0.26rem;
    position: absolute;
    left: 50%;
    right: auto;
    transform: translateY(-50%);
    min-width: 0.32rem;
    padding: 0 0.08rem;
  }
  .item-activity:before {
    content: '';
    display: inline-block;
    position: absolute;
    bottom: -0.06rem;
    z-index: 20;
    left: 0;
    width: 0;
    height: 0;
    border-left: 0.079rem solid red;
    border-top: 0.066rem solid transparent;
    border-bottom: 0.066rem solid transparent;
    font-size: 0;
  }
  .item-svg {
    width: 0.47rem;
    height: 0.47rem;
    position: absolute;
    left: 0;
    top: 0;
  }
  .item-text {
    height: auto;
    max-height: 0.66rem;
    line-height: 0.33rem;
    font-size: 0.24rem;
    margin-top: 0.1rem;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.moneybox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 1.06rem;
  font-size: 0.24rem;
  position: relative;
  flex-grow: 1;
  img {
    width: 0.66rem;
    height: 0.66rem;
    display: block;
    margin-bottom: 0.02rem;
  }
  span {
    max-height: 0.66rem;
    line-height: 0.33rem;
    width: 100%;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-word;
    font-size: 0.24rem;
  }
}

.CToeIaCnZ7Jr3D1XKTxw {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0.14rem 0.2rem 0.12rem;
  position: relative;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 {
  -ms-flex-pack: end;
  display: -ms-flexbox;
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 0.2rem;
  font-weight: 200;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 .So_waOZgg7qEl0wURIQz {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 .So_waOZgg7qEl0wURIQz .imageWrap {
  color: var(--theme-primary-color);
  font-size: 0.4rem;
  width: 0.4rem;
  height: 0.4rem;
}

.CToeIaCnZ7Jr3D1XKTxw .SVLWJ4WJI54O4lWBc7yk {
  display: -ms-flexbox;
  display: flex;
  margin-top: 0.2rem;
}

.wJ30VxmrZK3Y5gTd1Zq0 {
  color: var(--theme-mine-icon-color);
}

.VOgj9FBCnkozjr2NA7rl .refresh-icon {
  color: var(--theme-mine-icon-color) !important;
  width: 0.34rem;
  height: 0.34rem;
}

.vy918omw_N7rBkJ235XX .iw9FDOIygJyoQtUHSJAg > div {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
}

.glbY5bkp9x7KTYOGrdBC {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}

.CToeIaCnZ7Jr3D1XKTxw .zvrVqQuEWSzu7Nsavegl {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
}

.CToeIaCnZ7Jr3D1XKTxw .P_VF1DJcPs_q4ieRYz7n {
  border-radius: 50%;
  margin-right: 0.16rem;
  width: 0.98rem;
  height: 0.98rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.CToeIaCnZ7Jr3D1XKTxw .NeL_d0h5i7Kr9xdDCTty {
  font-size: 0.24rem;
  margin-bottom: 0.09rem;
}

.CToeIaCnZ7Jr3D1XKTxw .EpCtJEz_E_WMlMB6HeaI {
  margin-right: 0.1rem;
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.32rem;
}

.B8Z5jNPFB44UUahGOFBH {
  color: var(--theme-text-color);
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn .DnC6T98QN772WLPs1ooC {
  margin: 0 0.1rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .DnC6T98QN772WLPs1ooC
  .HiI_svzoqAjA6nNwGufG {
  color: var(--theme-text-color);
  font-size: 0.2rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .DnC6T98QN772WLPs1ooC
  .UNEMFCOoFUG1wM5qb0v8
  span {
  -ms-flex-align: center;
  align-items: center;
  display: inline-block;
  display: -ms-flexbox;
  display: flex;
  max-width: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn .VOgj9FBCnkozjr2NA7rl {
  border: none;
  position: inherit !important;
}

.Fn6L7w5ZEXiwo2fTNrRn .VOgj9FBCnkozjr2NA7rl .count-to {
  border-color: var(--theme-text-color-darken) !important;
  color: var(--theme-text-color-darken) !important;
  border-bottom: 0.02rem solid var(--theme-text-color-darken);
  display: inline-block;
  font-size: 0.32rem !important;
  margin: 0 0.1rem !important;
  max-width: 2.5rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .VOgj9FBCnkozjr2NA7rl
  .refresh-icon {
  color: var(--theme-mine-icon-color) !important;
  font-size: 0.28rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .VOgj9FBCnkozjr2NA7rl
  .currency-triangle {
  -webkit-transform: translate(-50%, 0.01rem) rotate(45deg);
  transform: translate(-50%, 0.01rem) rotate(45deg);
}

.PIj1PfbzHvacLB3SeEjQ {
  color: var(--theme-text-color-darken);
  margin-right: 0.06rem;
}

.SVLWJ4WJI54O4lWBcsdfsdf {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

._icon_1u010_65 {
  cursor: pointer;
  width: 0.88rem;
  height: 0.88rem;
  margin-right: 0.2rem;
}

.no-login-left {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.un-login-info-tips-label {
  color: var(--theme-text-color);
  font-size: 0.24rem;
  line-height: 1.35;
}
._action_1u010_97 {
  font-size: 0.24rem;
  color: var(--theme-text-color-darken);
  cursor: pointer;
  margin: 0 0.05rem;
}

.crcd82r1PVsQivOcCftk {
  display: flex;
  flex-direction: row;
  margin-top: 0.2rem;
}

.crcd82r1PVsQivOcCftk button {
  height: 0.51rem;
  font-size: 0.22rem;
  width: 1.2rem;
  padding: 0 0.2rem;
  border-radius: 0.1rem;
  margin-left: 0.2rem;
}
</style>
